import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';

const getImagePath = imgSrc => `${App_data.frontend_url}${imgSrc}`;

const IntroductionItems = [
  {
    id: '1',
    title: language.LC().INTROTITLE,
    content: [{ html: language.LC().INTROPARA }],
    buttonText: language.LC().NEXTTOCONTINUE,
  },
  {
    id: '2',
    title: language.LC().WELCOMETITLE,
    content: [{ html: language.LC().WELCOMEPARA }],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '3',
    title: language.LC().USEMOUSETITLE,
    content: [
      { image: getImagePath('/img/questions/icon_arrow.png') },
      { html: language.LC().USEMOUSEPARA },
    ],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '4',
    title: language.LC().NAVIGATTITLE,
    content: [
      { html: language.LC().NAVIGATPARA },
      { image: getImagePath('/img/questions/icon_tab_btn.png') },
      { html: language.LC().NAVIGATBUTTONINFO },
    ],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '5',
    title: language.LC().TIMEREMAINTITLE,
    content: [
      { html: language.LC().TIMEREMAINPARAONE },
      { image: getImagePath('/img/questions/img_time.png') },
      { html: language.LC().TIMEREMAINPARATWO },
    ],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '6',
    title: language.LC().FLAGTITLE,
    content: [
      { image: getImagePath('/img/questions/icon_flag_tag.png') },
      { html: language.LC().FLAGPARA },
      { image: getImagePath('/img/questions/icon_flag_tag_btn.png') },
      { html: language.LC().FLAGBUTTON },
    ],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '7',
    title: language.LC().ANSWERMULTTITLE,
    content: [{ html: language.LC().ANSWERMULTPARA }],
    imageSrc: '',
    buttonText: '',
    choices: [
      {
        letter: language.LC().A,
        answer: language.LC().ESTONIA,
      },
      {
        letter: language.LC().B,
        answer: language.LC().UKRAINE,
      },
      {
        letter: language.LC().C,
        answer: language.LC().BELGIUM,
      },
    ],
  },
  {
    id: '8',
    title: language.LC().REVIEWTITLE,
    content: [
      { html: language.LC().REVIEWPARA },
      { image: getImagePath('/img/questions/icon_menu.png') },
      { html: language.LC().REVIEWPARACLOSE },
      { image: getImagePath('/img/questions/img_sidebar.png') },
    ],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '9',
    title: language.LC().HIGHLIGHTINGTEXT,
    content: [
      { html: language.LC().HIGHLIGHTINGPARA },
      { image: getImagePath('/img/questions/img_highlight.png') },
      { html: language.LC().PLEASENOTE },
    ],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '10',
    title: language.LC().STRIKINGOUTOPTIONS,
    content: [{ html: language.LC().STRIKINGOUTOPTIONSPARA }],
    imageSrc: '',
    buttonText: '',
    choices: [
      {
        letter: language.LC().A,
        answer: language.LC().ESTONIA,
      },
      {
        letter: language.LC().B,
        answer: language.LC().UKRAINE,
      },
      {
        letter: language.LC().C,
        answer: language.LC().BELGIUM,
      },
    ],
  },
  {
    id: '11',
    title: language.LC().ENDINGEXAMTITLE,
    content: [{ html: language.LC().ENDINGEXAMPARA }],
    buttonText: language.LC().NEXTBUTTONCONTINUE,
  },
  {
    id: '12',
    title: language.LC().TUTORIALCONCLUSIONTITLE,
    content: [{ html: language.LC().TUTORIALCONCLUSIONPARA }],
    buttonText: language.LC().CLICKSTARTTEST,
  },
];
export default IntroductionItems;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/instructions.js